'use strict';

import React, { Component } from 'react';
import styled from 'styled-components';

var jsonData = require('./landingpagedata.json');

export default class CustomersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sectionTitle: jsonData.CustomersLogos.sectionTitle,
    }
  }

  render() {
    return (
      <Container>
      <SectionTitle >{jsonData.CustomersLogos.sectionTitle} </SectionTitle>  
        <Section>
          {this._renderLogos()}
        </Section>
      </Container>
    );
  }
 
  _renderLogos(){
    let result = [];
    
    //Sýn logo
    let eachItem = jsonData.CustomersLogos.logoCards[0];
    result.push(
      <ImageCard
        key={0}
        image={eachItem.imageSrc}
        imageLink={eachItem.link}
        imgWidth= {{'width':"160px",'minWidth':'140px'}}  />    
       );
  
    //sambandið logo
    eachItem = jsonData.CustomersLogos.logoCards[1];
    result.push(
      <ImageCard
        key={1}
        image={eachItem.imageSrc}
        imageLink={eachItem.link}
        imgWidth= {{'width':"110px",'minWidth':'100px'}}  />
       );
      
       //isi logo
       eachItem = jsonData.CustomersLogos.logoCards[2];
       result.push(
         <ImageCard
           key={2}
           image={eachItem.imageSrc}
           imageLink={eachItem.link}
           imgWidth= {{'width':"98px",'minWidth':'98px'}}  />
          );

        //RU logo
       eachItem = jsonData.CustomersLogos.logoCards[3];
       result.push(
         <ImageCard
           key={3}
           image={eachItem.imageSrc}
           imageLink={eachItem.link}
           imgWidth= {{'width':"105px",'minWidth':'95px'}}  />
          );

        //HA logo
       eachItem = jsonData.CustomersLogos.logoCards[4];
       result.push(
         <ImageCard
           key={4}
           image={eachItem.imageSrc}
           imageLink={eachItem.link}
           imgWidth= {{'width':"160px",'minWidth':'140px'}}  />
          );
  return (result);
  }
}


 class ImageCard extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const  {image,imageLink,altText,imgWidth} = this.props;
    return (
      <Card>
        <CardImageColumn >
          <a href={imageLink} target="_blank">
            <img src={image} alt={altText} style={imgWidth} />
          </a>
        </CardImageColumn>
      </Card>
    );
  }
}

/*
*  CustomerContainer styles
*/
const Container = styled.section`
  display: flex;    
  position: relative;  
  flex-direction: column;
  flex-wrap: wrap;
  background:#8ea9cc;
`;

const SectionTitle = styled.section`
    display: flex 1;
    height: 60px;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;

    margin-left: 1.8rem;
    color: #FFF;
    font-size: 1.3em;
    line-height: 1.2em;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-transform: uppercase;
`;

const Section = styled.section`
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 1.8rem;
`;


/*
*  TextCard styles
*/
//styled components
const Card = styled.section`
  flex-direction:column;
  flex: 1;
  align-items: flex-start;

  margin: 2.4rem 1.8rem 2.4rem ;
  min-height: auto;

  color: rgba(255,255,255,1.0);  
`;


/*
*  CardImage styles
*/
//Inline styling https://codeburst.io/4-four-ways-to-style-react-components-ac6f323da822


const CardImageColumn = styled.section`
  flex: 2 2;
  flex-direction: column;
  text-align: center;
`;
